import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { FuseSharedModule } from './../../../../@fuse/shared.module';

import { QuickPanelComponent } from './quick-panel.component';
import { QuickPanelComponentDynamic } from  './quick-panel-dynamic/quick-panel-dynamic.component';

@NgModule({
    declarations: [
        QuickPanelComponent,
        QuickPanelComponentDynamic
    ],
    imports     : [
        MatDividerModule,
        MatListModule,
        MatSlideToggleModule,

        FuseSharedModule,
    ],
    exports: [
        QuickPanelComponent,
        QuickPanelComponentDynamic
    ]
})
export class QuickPanelModule
{
}
